import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators } from "@angular/forms";
import { FormService } from "../../services/form.service";

@Component( {
	selector: 'app-property-type-details-to',
	templateUrl: './property-type-details-to.component.html',
	styleUrls: ['./property-type-details-to.component.scss']
} )
export class PropertyTypeDetailsToComponent implements OnInit {

	propertyTypeDetailsTo !: UntypedFormGroup
	formGroupName: string = 'propertyTypeDetailsTo'
	elevatorEnabled = false;
	floorLevels: any;

	constructor( public formService: FormService ) {

	}

	ngOnInit(): void {

		this.propertyTypeDetailsTo = this.formService.mainForm.get( this.formGroupName ) as UntypedFormGroup;
		this.floorLevels = this.formService.getFloorLevels();
	}

	onSubmit() {

		this.formService.submitFormGroup( (<UntypedFormGroup>this.propertyTypeDetailsTo) );
	}

	onFloorChange( $event: any ) {

		// If more floors than 0
		if( $event.value > 1 ) {

			// Show elevator field and make it required
			this.elevatorEnabled = true;

			(<UntypedFormGroup>this.propertyTypeDetailsTo).controls['elevator'].addValidators( Validators.required );

		} else {

			// Hide elevator and make it un-required
			this.elevatorEnabled = false;

			(<UntypedFormGroup>this.propertyTypeDetailsTo).controls['elevator'].removeValidators( Validators.required );
			(<UntypedFormGroup>this.propertyTypeDetailsTo).controls['elevator'].reset();
		}
	}

	onElevatorChange() {

		// Small timeout for user experience
		setTimeout( () => {

			this.onSubmit();
		}, 200 );
	}
}
